<template>
  <v-container>
    <div
      :class="[`text-subtitle-1`]"
    >
      <h4>Education(s)</h4>
    </div>
    <div
      class="card grey-card"
      v-for="(item, i) in education_list"
      :key="i"
    >
      <v-row>
        <v-col md="11" sm="10" cols="10">
          <v-row>
            <v-col md="6" cols="12">
              <v-text-field
                v-model="education_list[i].school"
                label="School name"
                outlined
                dense
              />
            </v-col>
            <v-col md="6" cols="12">
              <v-text-field
                v-model="education_list[i].level"
                label="Education level"
                outlined
                dense
              />
            </v-col>
            <v-col md="4" cols="6">
              <v-text-field
                v-model="education_list[i].start_date"
                label="Start date"
                outlined
                dense
              />
            </v-col>
            <v-col md="4" cols="6">
              <v-text-field
                v-model="education_list[i].end_date"
                label="End date"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col md="1" sm="2" cols="2">
          <v-btn
            @click="removeEducation(i)"
            small
            text
            color="red"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-btn
      @click="addEducation()"
      small
    >
      Add education
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: 'SupporterEducation',
  props: ['education_list', 'remove_educations'],
  methods: {
    addEducation () {
      this.education_list.push({ school: '', level: '', start_date: '', end_date: '' })
    },
    removeEducation (index) {
      if (this.education_list[index].id)
        this.remove_educations.push(this.education_list[index].id)
      this.education_list.splice(index, 1)
    }
  },
}
</script>